import React from 'react';
import HeroBannerV3 from '@ajat/design-system/ContentBlocks/HeroBannerV3';
import { ComponentPage, DemoCard } from '../../shared';
import { HERO } from './contentDemoData';

export const meta = {
  component: HeroBannerV3,
  title: 'Hero Banner V3',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/HeroBannerV3',
  figmaNode: '2217:151672',
  description:
    'Split hero on a warm gradient (OVER-LL): eyebrow, editorial headline with an accented tail, copy, a CTA button + a regular Hyperlink and a desktop-only stats row on the left; a square visual on the right — an image, or a muted looping video that fades in over that image once it can play (the image stays as the fallback). Mobile (2645:13284) puts the visual first and drops the stats.',
  props: [
    ['subtitle', 'string', "''", 'Eyebrow: 24px rule + uppercase text'],
    ['title', 'string', "''", 'Headline (typo-h1-editorial)'],
    ['titleAccent', 'string', "''", 'Tail of the headline in --color-brand-primary-alternative'],
    ['copy', 'string', "''", 'Body copy'],
    ['ctaLabel', 'string', "''", 'Primary CTA (Button secondary / main)'],
    ['ctaIcon', 'node', '<ArrowRight />', 'Primary CTA icon'],
    ['ctaVariant', 'string', "'main'", 'Primary CTA Button variant'],
    ['ctaClassName', 'string', "''", 'Extra class on the primary CTA (placement only; the Overall landing passes `ctaVariant="hero"`)'],
    ['ctaHref', 'string', '—', 'Primary CTA link target — renders it as a real link'],
    ['ctaOnClick', 'func', '—', 'Primary CTA handler'],
    ['secondaryLabel', 'string', "''", 'Secondary link (DS Hyperlink regular)'],
    ['secondaryHref', 'string', "''", 'Secondary link href; omitted = click-only'],
    ['secondaryOnClick', 'func', '—', 'Secondary link handler'],
    ['stats', 'array', '[]', '[{ label, value }] — desktop only'],
    ['reveal', 'bool', 'false', 'BlurReveal entrance across the hero: eyebrow → headline glyphs → copy → buttons → stats, visual fading in alongside'],
    ['titleReveal', 'string', "'words'", 'Headline entrance with reveal: words (fade + lift per word, 2px blur) | glyphs (blur) | lines | rows | glyphs-plain'],
    ['burst', 'array', '[]', 'PatchBurst scene over the text column during the reveal (PatchBurst items; needs reveal)'],
    ['image', 'string', '—', 'Desktop visual; with video, the still shown until the clip can play'],
    ['imageMobile', 'string', '—', 'Mobile visual (falls back to image)'],
    ['imageAlt', 'string', "''", 'Alt text'],
    ['video', 'string', '—', 'Muted autoplay loop that fades in over the picture once it can play'],
    ['visualPosition', "'end' | 'start'", "'end'", "Desktop side of the visual — the DS name shared with ContentBanner / ContentBannerV2 ('right' / 'left' still accepted); mobile always stacks it first"],
    ['background', 'string', 'warm gradient', 'Section background override'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'On the OVER/LL landing',
      code: `import HeroBannerV3 from '@ajat/design-system/ContentBlocks/HeroBannerV3';

<HeroBannerV3
  subtitle="Designed in Stockholm"
  title="Official uniform of"
  titleAccent="unofficial behavior"
  copy="Designa din studentoverall från grunden eller börja med en edition."
  ctaLabel="Designa editions"
  ctaOnClick={() => navigate('/overalls/configurator')}
  secondaryLabel="Designa free"
  stats={[{ label: 'Från', value: '299 kr' }, { label: 'Patchar', value: '500+' }]}
  reveal
  burst={HERO_BURST}
  image={overallRender}
  video={heroClip}
/>`,
    },
  ],
};

export default function HeroBannerV3Page() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Image, two buttons, stats" hint="Figma 2217:151672 · stats hide below 1024px · reveal + patch burst play once on mount" flush>
        <HeroBannerV3 {...HERO} reveal />
      </DemoCard>
    </ComponentPage>
  );
}
